module.exports = __webpack_public_path__ + "img/icon-sale-add.07d288ae.png";